// Aggregate persisted execution statistics; media duration is not inferred from event counts.
export function executionUsage(rows: Array<{ project_id?: string; workspace_id?: string; status: string; runs: number }>, workspaceId?: string | null) {
  const counts: Record<string, number> = { completed:0, failed:0, cancelled:0, running:0, queued:0 };
  const projects = new Map<string, { id:string; total:number; completed:number; failed:number }>();
  let total = 0;
  for (const row of rows) {
    if (workspaceId && row.workspace_id !== workspaceId) continue;
    const count = Number(row.runs) || 0;
    total += count;
    counts[row.status] = (counts[row.status] || 0) + count;
    const id = row.project_id || '';
    const project = projects.get(id) || { id, total:0, completed:0, failed:0 };
    project.total += count;
    if (row.status === 'completed' || row.status === 'failed') project[row.status] += count;
    projects.set(id, project);
  }
  return { total, counts, projects:[...projects.values()].sort((a, b) => b.total - a.total) };
}
